export default __webpack_public_path__ + "5552726b5afda1f5ff32885c08967724.svg";